import { AnyAction } from 'redux';

//tworzenie oceny końcowej
export const CREATE_FINAL_MARK_STARTED = 'CREATE_FINAL_MARK_STARTED';
export const CREATE_FINAL_MARK_SUCCESS = 'CREATE_FINAL_MARK_SUCCESS';
export const CREATE_FINAL_MARK_FAIL = 'CREATE_FINAL_MARK_FAIL';

//tworzenie wielu ocen końcowych
export const CREATE_FINAL_MARKS_STARTED = 'CREATE_FINAL_MARKS_STARTED';
export const CREATE_FINAL_MARKS_SUCCESS = 'CREATE_FINAL_MARKS_SUCCESS';
export const CREATE_FINAL_MARKS_FAIL = 'CREATE_FINAL_MARKS_FAIL';

//edycja oceny końcowej
export const UPDATE_FINAL_MARK_STARTED = 'UPDATE_FINAL_MARK_STARTED';
export const UPDATE_FINAL_MARK_SUCCESS = 'UPDATE_FINAL_MARK_SUCCESS';
export const UPDATE_FINAL_MARK_FAIL = 'UPDATE_FINAL_MARK_FAIL';

//edycja wielu ocen końcowych
export const UPDATE_FINAL_MARKS_STARTED = 'UPDATE_FINAL_MARKS_STARTED';
export const UPDATE_FINAL_MARKS_SUCCESS = 'UPDATE_FINAL_MARKS_SUCCESS';
export const UPDATE_FINAL_MARKS_FAIL = 'UPDATE_FINAL_MARKS_FAIL';

//tworzenie oceny cząstkowej
export const CREATE_PARTIAL_MARK_STARTED = 'CREATE_PARTIAL_MARK_STARTED';
export const CREATE_PARTIAL_MARK_SUCCESS = 'CREATE_PARTIAL_MARK_SUCCESS';
export const CREATE_PARTIAL_MARK_FAIL = 'CREATE_PARTIAL_MARK_FAIL';

//tworzenie wielu ocen cząstkowych
export const CREATE_PARTIAL_MARKS_STARTED = 'CREATE_PARTIAL_MARKS_STARTED';
export const CREATE_PARTIAL_MARKS_SUCCESS = 'CREATE_PARTIAL_MARKS_SUCCESS';
export const CREATE_PARTIAL_MARKS_FAIL = 'CREATE_PARTIAL_MARKS_FAIL';

//edycja oceny cząstkowej
export const UPDATE_PARTIAL_MARK_STARTED = 'UPDATE_PARTIAL_MARK_STARTED';
export const UPDATE_PARTIAL_MARK_SUCCESS = 'UPDATE_PARTIAL_MARK_SUCCESS';
export const UPDATE_PARTIAL_MARK_FAIL = 'UPDATE_PARTIAL_MARK_FAIL';

//edycja wielu ocen cząstkowych
export const UPDATE_PARTIAL_MARKS_STARTED = 'UPDATE_PARTIAL_MARKS_STARTED';
export const UPDATE_PARTIAL_MARKS_SUCCESS = 'UPDATE_PARTIAL_MARKS_SUCCESS';
export const UPDATE_PARTIAL_MARKS_FAIL = 'UPDATE_PARTIAL_MARKS_FAIL';

//usuwanie oceny cząstkowej
export const DELETE_PARTIAL_MARK_STARTED = 'DELETE_PARTIAL_MARK_STARTED';
export const DELETE_PARTIAL_MARK_SUCCESS = 'DELETE_PARTIAL_MARK_SUCCESS';
export const DELETE_PARTIAL_MARK_FAIL = 'DELETE_PARTIAL_MARK_FAIL';

//usuwanie wielu ocen cząstkowych
export const DELETE_PARTIAL_MARKS_STARTED = 'DELETE_PARTIAL_MARKS_STARTED';
export const DELETE_PARTIAL_MARKS_SUCCESS = 'DELETE_PARTIAL_MARKS_SUCCESS';
export const DELETE_PARTIAL_MARKS_FAIL = 'DELETE_PARTIAL_MARKS_FAIL';

//usuwanie oceny końcowej
export const DELETE_FINAL_MARK_STARTED = 'DELETE_FINAL_MARK_STARTED';
export const DELETE_FINAL_MARK_SUCCESS = 'DELETE_FINAL_MARK_SUCCESS';
export const DELETE_FINAL_MARK_FAIL = 'DELETE_FINAL_MARK_FAIL';

//podpisywanie ocen - KROK 1
export const OPEN_SIGN_MARK_MODAL = 'OPEN_SIGN_MARK_MODAL';
export const CLOSE_SIGN_MARK_MODAL = 'CLOSE_SIGN_MARK_MODAL';
export const SIGN_MARKS_START = 'SIGN_MARKS_START';
export const SIGN_MARKS_SUCCESS = 'SIGN_MARKS_SUCCESS';
export const SIGN_MARKS_FAIL = 'SIGN_MARKS_FAIL';

//podpisywanie ocen - KROK 2 (kod sms/email)
export const OPEN_CONFIRM_CODE_MARK_MODAL = 'OPEN_CONFIRM_CODE_MARK_MODAL';
export const CLOSE_CONFIRM_CODE_MARK_MODAL = 'CLOSE_CONFIRM_CODE_MARK_MODAL';
export const CONFIRM_CODE_START = 'CONFIRM_CODE_START';
export const CONFIRM_SMS_CODE_SUCCESS = 'CONFIRM_SMS_CODE_SUCCESS';
export const CONFIRM_SMS_CODE_FAIL = 'CONFIRM_SMS_CODE_FAIL';
export const CONFIRM_EMAIL_CODE_SUCCESS = 'CONFIRM_EMAIL_CODE_SUCCESS';
export const CONFIRM_EMAIL_CODE_FAIL = 'CONFIRM_EMAIL_CODE_FAIL';

//podpisywanie ocen złożone - wybór pracownika potwierdzającego
export const OPEN_EMPLOYEE_CONFIRM_MARK_MODAL = 'OPEN_EMPLOYEE_CONFIRM_MARK_MODAL';
export const CLOSE_EMPLOYEE_CONFIRM_MARK_MODAL = 'CLOSE_EMPLOYEE_CONFIRM_MARK_MODAL';
export const SET_EMPLOYEE_CONFIRM_MARK_MODAL = 'SET_EMPLOYEE_CONFIRM_MARK_MODAL';
export const EMPLOYEE_CONFIRM_START = 'EMPLOYEE_CONFIRM_START';
export const EMPLOYEE_CONFIRM_SUCCESS = 'EMPLOYEE_CONFIRM_SUCCESS';
export const EMPLOYEE_CONFIRM_FAIL = 'EMPLOYEE_CONFIRM_FAIL';

//podpisywanie ocen złożone - wysłanie kodu email pracownika
export const OPEN_EMPLOYEE_CODE_MARK_MODAL = 'OPEN_EMPLOYEE_CODE_MARK_MODAL';
export const CLOSE_EMPLOYEE_CODE_MARK_MODAL = 'CLOSE_EMPLOYEE_CODE_MARK_MODAL';
export const EMPLOYEE_CODE_START = 'EMPLOYEE_CODE_START';
export const EMPLOYEE_CODE_SUCCESS = 'EMPLOYEE_CODE_SUCCESS';
export const EMPLOYEE_CODE_FAIL = 'EMPLOYEE_CODE_FAIL';

//podpisywanie ocen - krok ostatni - podpisanie
export const FINAL_CONFIRM_START = 'FINAL_CONFIRM_START';
export const FINAL_CONFIRM_SUCCESS = 'FINAL_CONFIRM_SUCCESS';
export const FINAL_CONFIRM_FAIL = 'FINAL_CONFIRM_FAIL';

export const EXECUTE_SIGN_MARKS_ERROR_CODE = 'EXECUTE_SIGN_MARKS_ERROR_CODE';
export const CANCEL_SIGN_MARKS = 'CANCEL_SIGN_MARKS';

export const REFRESH_DATA_AFTER_MARKS_SIGNING = 'REFRESH_DATA_AFTER_MARKS_SIGNING';

export interface UniqueData {
  kodWydzialu: string;
  kodPrzedmiotu: string;
  typKartyPrzedmiotu: string;
  // albumId: string | number;
  kartaPrzedmiotId: string | number;
  rokAkademicki: string;
  semestrAkademicki: string;
  ocena?: string;
  obligatoryjnaDataWystawienia?: number;
  formaZajec?: string;
  wagaFormyZajec?: string;
  typPrzydzialu: string;
}

interface MarkActionCommonPayload {
  tab: {
    tabId: number;
    studentId: number | string;
  };
  refreshDataAction: any;
}
interface SingleMarkPayload extends MarkActionCommonPayload {
  data: UniqueData;
}
interface GroupMarkPayload extends MarkActionCommonPayload {
  data: UniqueData[];
}
//obsługa akcji dotyczących pojedynczej oceny
interface CreatePartialMark {
  type: typeof CREATE_PARTIAL_MARK_STARTED;
  payload: SingleMarkPayload;
}
interface UpdatePartialMark {
  type: typeof UPDATE_PARTIAL_MARK_STARTED;
  payload: SingleMarkPayload;
}
interface DeletePartialMark {
  type: typeof DELETE_PARTIAL_MARK_STARTED;
  payload: SingleMarkPayload;
}
interface CreateFinalMark {
  type: typeof CREATE_FINAL_MARK_STARTED;
  payload: SingleMarkPayload;
}
interface UpdateFinalMark {
  type: typeof UPDATE_FINAL_MARK_STARTED;
  payload: SingleMarkPayload;
}
interface DeleteFinalMark {
  type: typeof DELETE_FINAL_MARK_STARTED;
  payload: SingleMarkPayload;
}
//obsługa akcji grupowych
interface CreatePartialMarks {
  type: typeof CREATE_PARTIAL_MARKS_STARTED;
  payload: GroupMarkPayload;
}
interface UpdatePartialMarks {
  type: typeof UPDATE_PARTIAL_MARKS_STARTED;
  payload: GroupMarkPayload;
}
interface DeletePartialMarks {
  type: typeof DELETE_PARTIAL_MARKS_STARTED;
  payload: GroupMarkPayload;
}
interface CreateFinalMarks {
  type: typeof CREATE_FINAL_MARKS_STARTED;
  payload: GroupMarkPayload;
}
interface UpdateFinalMarks {
  type: typeof UPDATE_FINAL_MARKS_STARTED;
  payload: GroupMarkPayload;
}
interface OpenSignModal {
  type: typeof OPEN_SIGN_MARK_MODAL;
  payload: MarksData;
}
interface CloseSignModal {
  type: typeof CLOSE_SIGN_MARK_MODAL;
}
interface SignMarks {
  type: typeof SIGN_MARKS_START;
}
interface OpenConfirmCodeModal {
  type: typeof OPEN_CONFIRM_CODE_MARK_MODAL;
  payload: { mode: MarksState['codeConfirmModal']['mode'] };
}
interface CloseConfirmCodeModal {
  type: typeof CLOSE_CONFIRM_CODE_MARK_MODAL;
}
interface ConfirmCodeMarks {
  type: typeof CONFIRM_CODE_START;
  payload: { code: string; mode: MarksState['codeConfirmModal']['mode'] };
}

interface OpenEmployeeConfirmModal {
  type: typeof OPEN_EMPLOYEE_CONFIRM_MARK_MODAL;
}
interface CloseEmployeeConfirmModal {
  type: typeof CLOSE_EMPLOYEE_CONFIRM_MARK_MODAL;
}
interface SetEmployeeConfirmModal {
  type: typeof SET_EMPLOYEE_CONFIRM_MARK_MODAL;
  payload: { value: string };
}
interface ConfirmEmployeeConfirmModal {
  type: typeof EMPLOYEE_CONFIRM_START;
}

interface OpenConfirmEmployeeCodeModal {
  type: typeof OPEN_EMPLOYEE_CODE_MARK_MODAL;
}
interface CloseConfirmEmployeeCodeModal {
  type: typeof CLOSE_EMPLOYEE_CODE_MARK_MODAL;
}
interface ConfirmEmployeeCodeMarks {
  type: typeof EMPLOYEE_CODE_START;
  payload: { code: string };
}
interface ExecuteErrorCodeTypes {
  type: typeof EXECUTE_SIGN_MARKS_ERROR_CODE;
  payload: { code: number; failedAction: AnyAction; error: any };
}

export interface StudentData {
  firstName: string;
  lastName: string;
  albumId: string | number;
  ocena: string;
  obligatoryjnaDataWystawienia: number;
  studentWydzial: string;
  studentId: number;
}

export interface MarksData {
  studentList: StudentData[];
  semestrAkademicki: string | null;
  rokAkademicki: number | string | null;
  przedmiotKod: number | string | null;
  wydzialZlecajacyKod: string | null;
  wydzialZlecajacyNazwa: string | null;
  przedmiotNazwa: string | null;
  tabId: DynamicTabComponent['id'] | null;
}

interface Signing extends MarksData {
  opened: boolean;
  loading: boolean;
  error: boolean;
  controlSum: string | null;
}

interface Employee {
  imie: string;
  nazwisko: string;
  pracownikId: string;
}
export interface MarksState {
  mainLoader: boolean;
  partialMarks: {
    loading: boolean;
    error: boolean;
  };
  finalMarks: {
    loading: boolean;
    error: boolean;
  };
  signing: Signing;
  codeConfirmModal: {
    opened: boolean;
    loading: boolean;
    error: boolean;
    mode: 'sms' | 'email';
  };
  emailEmployeeCodeConfirmModal: {
    opened: boolean;
    loading: boolean;
    error: boolean;
  };
  employeeConfirmModal: {
    opened: boolean;
    loading: boolean;
    value: string | null;
    error: boolean;
    list: Employee[];
  };
}

export type MarksActionTypes =
  OpenConfirmCodeModal |
  CloseConfirmCodeModal |
  ConfirmCodeMarks |
  CreatePartialMark |
  UpdatePartialMark |
  DeletePartialMark |
  CreateFinalMark |
  UpdateFinalMark |
  DeleteFinalMark |
  CreatePartialMarks |
  UpdatePartialMarks |
  DeletePartialMarks |
  CreateFinalMarks |
  OpenSignModal |
  CloseSignModal |
  SignMarks |
  OpenEmployeeConfirmModal |
  CloseEmployeeConfirmModal |
  SetEmployeeConfirmModal |
  ConfirmEmployeeConfirmModal |
  OpenConfirmEmployeeCodeModal |
  CloseConfirmEmployeeCodeModal |
  ConfirmEmployeeCodeMarks |
  ExecuteErrorCodeTypes |
  UpdateFinalMarks;
